/**
 * Application Constants
 */

// Shared colors (same across brands)
const SHARED_RED = [231, 76, 60];
const SHARED_LIGHT_GREEN = [232, 245, 233];

// Brand-specific configurations
const BRAND_CONFIGS = {
  "EasySmile-4all": {
    SERVICES_JSON_PATH: "/services.json",
    LOGO: "/assets/easySmile/easysmile.png",
    DOWN_WAVE: "/assets/easySmile/downWave.svg",
    QR_CODE_SECTION: "/assets/migrosQrCode.png",
    COLORS: {
      TEAL: [81, 161, 171], // #51A1AB
      RED: SHARED_RED,
      LIGHT_GREEN: SHARED_LIGHT_GREEN,
    },
  },
  SwissAligner: {
    SERVICES_JSON_PATH: "/services-swissaligner.json",
    LOGO: "/assets/swissaligner/SwissAlignerLogo.svg",
    LOGO_PNG: "/assets/swissaligner/swissAlignerLogo.png",
    DOWN_WAVE: "/assets/swissaligner/downWave.svg",
    QR_CODE_SECTION: "/assets/easySmile/qrCodeSection.png",
    COLORS: {
      TEAL: [45, 56, 132], // #2D3884
      RED: SHARED_RED,
      LIGHT_GREEN: SHARED_LIGHT_GREEN,
    },
  },
};

// Helper function to get brand config
export const getBrandConfig = (brand) => {
  return BRAND_CONFIGS[brand] || BRAND_CONFIGS["EasySmile-4all"];
};

/** @param {string} [brand] */
export function getBrandHex(brand) {
  const { COLORS } = getBrandConfig(brand);
  const teal = COLORS.TEAL;
  return `#${teal.map((c) => c.toString(16).padStart(2, "0")).join("")}`;
}

const defaultBrandConfig = getBrandConfig("EasySmile-4all");

export const CONFIG = {
  // API & Data
  SERVICES_JSON_PATH: "/services.json", // Default, will be overridden by brand

  // Invoice Settings
  INVOICE: {
    DEFAULT_ID: "#1",
    COMPANY: {
      NAME: "EasySmile4all",
      ADDRESS: "21 pl. d'Armes, 1227, GE",
      WEBSITE: "www.swissaligner.com",
      PHONE: "+41 22 301 09 79",
    },
    PAYMENT: {
      IBAN: "CH34 0840 1000 0626 5743 7",
      RECIPIENT: "Ortholabo, Hilal Kassab",
      ADDRESS: "place d'Armes 21, 1227 Carouge GE",
    },
    COLORS: defaultBrandConfig.COLORS,
  },

  // Form Defaults
  FORM: {
    TREATMENT_DURATION_OPTIONS: [6, 12, 24],
    TOTAL_PRICE_OPTIONS: [3300, 3600, 3900],
    QUANTITY_MAX: 100,
    DEFAULT_POINT_VALUE: 1.0, // Default multiplier for converting points to prices
  },

  // Assets (served from public folder in Vite)
  ASSETS: {
    LOGO: defaultBrandConfig.LOGO,
    QR_CODE: "/assets/easySmile/qrCode.png",
    QR_CODE_SECTION: defaultBrandConfig.QR_CODE_SECTION,
    /** Doctor billing: Migros QR for EasySmile-4all and Jacoby; UBS for the rest */
    DOCTOR_BILLING_QR_MIGROS: "/assets/migrosQrCode.png",
    DOCTOR_BILLING_QR_UBS: "/assets/ubsQrCode.png",
    DOWN_WAVE: defaultBrandConfig.DOWN_WAVE,
    TEMPLATE_PATH: "/assets/easySmile/",
  },

  // PDF Settings
  PDF: {
    FORMAT: "a4",
    ORIENTATION: "p",
    UNIT: "mm",
  },

  // Brand configs
  BRAND_CONFIGS,
};

/**
 * Returns the doctor billing QR code asset path: Migros for EasySmile-4all and Jacoby, UBS for the rest.
 * @param {string} [doctorName] - Cabinet/doctor name
 * @returns {string} Path to QR image (e.g. /assets/migrosQrCode.png or /assets/ubsQrCode.png)
 */
export function getDoctorBillingQrPath(doctorName) {
  const name = (doctorName ?? "").toLowerCase();
  const useMigros =
    name.includes("jacoby") ||
    name.includes("easysmile") ||
    name.includes("easy-smile");
  return useMigros
    ? CONFIG.ASSETS.DOCTOR_BILLING_QR_MIGROS
    : CONFIG.ASSETS.DOCTOR_BILLING_QR_UBS;
}
